import React, { useEffect, useState } from "react";

const IMAGE_EXTS = /\.(png|jpg|jpeg|gif|webp|bmp|tiff?)$/i;
const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3;
const ZOOM_STEP = 0.25;

function clampZoom(value) {
    return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, value));
}

export default function PdfViewer({ url, fileName }) {
    const [zoom, setZoom] = useState(1);

    useEffect(() => {
        setZoom(1);
    }, [url, fileName]);

    if (!url) return null;

    if (fileName && IMAGE_EXTS.test(fileName)) {
        return (
            <div style={{ width: "100%", height: "100%", minHeight: 0, display: "flex", flexDirection: "column", background: "#0f172a" }}>
                <div style={{
                    flex: "0 0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    padding: "8px 10px",
                    background: "#f8fafc",
                    borderBottom: "1px solid #e2e8f0",
                }}>
                    <button
                        type="button"
                        aria-label="Dézoomer l'image"
                        title="Dézoomer"
                        disabled={zoom <= MIN_ZOOM}
                        onClick={() => setZoom(current => clampZoom(current - ZOOM_STEP))}
                        style={zoomButtonStyle(zoom <= MIN_ZOOM)}
                    >
                        −
                    </button>
                    <button
                        type="button"
                        aria-label="Réinitialiser le zoom"
                        title="Réinitialiser"
                        onClick={() => setZoom(1)}
                        style={{ ...zoomButtonStyle(false), width: "58px", fontSize: "12px", fontWeight: 700 }}
                    >
                        {Math.round(zoom * 100)}%
                    </button>
                    <button
                        type="button"
                        aria-label="Zoomer l'image"
                        title="Zoomer"
                        disabled={zoom >= MAX_ZOOM}
                        onClick={() => setZoom(current => clampZoom(current + ZOOM_STEP))}
                        style={zoomButtonStyle(zoom >= MAX_ZOOM)}
                    >
                        +
                    </button>
                </div>
                <div style={{ flex: "1 1 auto", minHeight: 0, overflow: "auto", display: "flex", alignItems: zoom === 1 ? "center" : "flex-start", justifyContent: "center" }}>
                    <div style={{ width: `${zoom * 100}%`, height: `${zoom * 100}%`, flex: "0 0 auto", display: "flex", alignItems: "center", justifyContent: "center", padding: "10px" }}>
                        <img
                            src={url}
                            alt={fileName}
                            style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <iframe
            src={url}
            title="Visionneuse"
            style={{ width: "100%", height: "100%", border: "none" }}
        />
    );
}

function zoomButtonStyle(disabled) {
    return {
        width: "32px",
        height: "28px",
        borderRadius: "6px",
        border: "1px solid #cbd5e1",
        background: disabled ? "#f1f5f9" : "white",
        color: disabled ? "#94a3b8" : "#0f172a",
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: "17px",
        lineHeight: 1,
        fontWeight: 800,
    };
}
